"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../core/utils");

var CompetitorsPriority_1 = require("../model/CompetitorsPriority");

var CompetitorsPriorityConverter_1 = require("./CompetitorsPriorityConverter");

var CompetitorsPriorityConverterImpl =
/*#__PURE__*/
function (_CompetitorsPriorityC) {
  _inherits(CompetitorsPriorityConverterImpl, _CompetitorsPriorityC);

  function CompetitorsPriorityConverterImpl() {
    _classCallCheck(this, CompetitorsPriorityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorsPriorityConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorsPriorityConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CompetitorsPriority_1.CompetitorsPriority(CompetitorsPriority_1.CompetitorsPriority.schema.id.valueOf(conversions.documentToClassId(source)), CompetitorsPriority_1.CompetitorsPriority.schema.title.valueOf(source.title), CompetitorsPriority_1.CompetitorsPriority.schema.competitors.valueOf(conversions.asObjectList(source, 'competitors', function (value) {
        if (utils_1.Utils.isValueMissing(value)) {
          throw new DataDictionaryError_1.DataDictionaryError("competitor id cannot be empty!");
        }

        return conversions.toClassReferenceId(value);
      })), CompetitorsPriority_1.CompetitorsPriority.schema.archived.valueOf(source.archived));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        title: source.title,
        competitors: conversions.asObjectArray(source, 'competitors', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        archived: source.archived
      });
      return document;
    }
  }]);

  return CompetitorsPriorityConverterImpl;
}(CompetitorsPriorityConverter_1.CompetitorsPriorityConverter);

exports.CompetitorsPriorityConverterImpl = CompetitorsPriorityConverterImpl;